import React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import ToolbarTooltip from './ToolbarTooltip';

interface ToolbarButtonProps {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
  selected?: boolean;
  loading?: boolean;
  description?: string;
  disabledDescription?: string;
  tooltipTitle?: string;
}

const ToolbarButton = ({
  label,
  icon,
  onClick,
  disabled,
  selected,
  loading,
  description,
  disabledDescription,
  tooltipTitle,
}: ToolbarButtonProps) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 48 }}>
    <ToolbarTooltip
      title={tooltipTitle ?? label}
      description={disabled && disabledDescription ? disabledDescription : description}
    >
      <IconButton
        size="small"
        aria-label={tooltipTitle ?? label}
        onClick={onClick}
        disabled={disabled}
        sx={selected ? {
          bgcolor: 'action.selected',
          color: 'inherit',
          '&:hover': { bgcolor: 'action.selected' },
        } : undefined}
      >
        {loading ? <CircularProgress color="inherit" size={18} /> : icon}
      </IconButton>
    </ToolbarTooltip>
    <Typography
      variant="caption"
      sx={{
        fontSize: 10,
        lineHeight: 1.1,
        textAlign: 'center',
        color: disabled ? 'text.disabled' : 'text.primary',
      }}
    >
      {label}
    </Typography>
  </Box>
);

export default ToolbarButton;
